import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Button, Container } from "react-bootstrap";
import classes from "../WebsiteManagement/websiteManagement.module.css";
import Page from "../pagination/pagination";
import {
  GetAdminHotelBookings,
  DownloadHotelBookingTicket,
  DownloadHotelBookingInvoice,
  DownloadBookingTicket,
  DownloadBookingInvoice,
} from "../../entities/action/action";

const PAGE_SIZE = 50;

const thStyle = { padding: "10px 6px", textAlign: "left", fontSize: 12, fontWeight: 600, borderBottom: "2px solid #ccc", whiteSpace: "nowrap" };
const tdStyle = { padding: "10px 6px", fontSize: 12, borderBottom: "1px solid #eee", verticalAlign: "top" };

const HotelBookings = () => {
  const [all, setAll] = useState([]);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    (async () => {
      const res = await GetAdminHotelBookings();
      if (!res.success) return;
      const legacy = (res.bookings || []).map((b) => ({
        key: `hotel-${b.id}`,
        created: b.created,
        hotelName: b.hotelName,
        checkIn: b.checkIn,
        checkOut: b.checkOut,
        roomName: b.roomName,
        roomSetName: b.roomSetName,
        roomCount: b.roomCount,
        adults: b.adults,
        children: b.children,
        name: b.name,
        phone: b.phoneNo,
        email: b.emailId,
        bookingRef: b.bookingId,
        status: b.status,
        baseAmount: Number(b.mrp || 0) / 100,
        purchaseAmount: Number(b.sellingPrice || 0) / 100,
        downloadTicket: () => DownloadHotelBookingTicket(b.id),
        downloadInvoice: () => DownloadHotelBookingInvoice(b.id),
      }));
      const embark = (res.embarkBookings || []).map((b) => ({
        key: `embark-${b.bookingId}`,
        created: b.orderDate,
        hotelName: b.hotelName,
        checkIn: b.checkInDate,
        checkOut: b.checkOutDate,
        roomName: b.roomName,
        cityName: b.cityName,
        name: b.name,
        phone: b.phone,
        bookingRef: b.bookingRef || b.confirmationNo || b.bookingId,
        status: b.status,
        baseAmount: Number(b.amount || 0) / 100,
        purchaseAmount: null,
        downloadTicket: () => DownloadBookingTicket(b.bookingId),
        downloadInvoice: () => DownloadBookingInvoice(b.bookingId, `Hotel_Invoice_${b.bookingRef || b.bookingId}.pdf`),
      }));
      setAll([...embark, ...legacy]);
    })();
  }, []);

  useEffect(() => { setPage(1); }, [search]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return all;
    return all.filter(
      (b) =>
        (b.name || "").toLowerCase().includes(q) ||
        String(b.phone || "").toLowerCase().includes(q) ||
        (b.hotelName || "").toLowerCase().includes(q)
    );
  }, [all, search]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const pageItems = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <Fragment>
      <Container style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
        <form onSubmit={(e) => e.preventDefault()} style={{ display: "flex", alignItems: "stretch", width: "50vw" }}>
          <input className={classes.SearchInput} placeholder="Search by Name, Phone, or Hotel" value={searchInput}
            onChange={(e) => { setSearchInput(e.target.value); setSearch(e.target.value); }} />
          <button type="button" className={classes.SearchButton} onClick={() => setSearch(searchInput)}>Search</button>
        </form>
      </Container>
      {pageItems.length ? (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1100 }}>
            <thead>
              <tr style={{ backgroundColor: "#585858", color: "#fff" }}>
                <th style={thStyle}>Booking Date & Time</th>
                <th style={thStyle}>Hotel & Check-in/Check-out</th>
                <th style={thStyle}>Room Details</th>
                <th style={thStyle}>Traveller's Name & Details</th>
                <th style={thStyle}>PNR & Hotel Details</th>
                <th style={thStyle}>Seat Details</th>
                <th style={thStyle}>Booked / Rejected</th>
                <th style={thStyle}>Base Amount</th>
                <th style={thStyle}>Purchase Amount</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pageItems.map((item) => {
                const orderDate = new Date(item?.created);
                const cancelled = (item.status || "").toUpperCase().includes("CANCEL");
                return (
                  <tr key={item.key} style={{ backgroundColor: "#f9f9f9" }}>
                    <td style={tdStyle}>
                      {Number.isNaN(orderDate.getTime()) ? "—" : `${orderDate.getDate()}/${orderDate.getMonth() + 1}/${orderDate.getFullYear()}`}
                      {!Number.isNaN(orderDate.getTime()) && <div style={{ color: "gray" }}>{orderDate.toLocaleTimeString()}</div>}
                    </td>
                    <td style={tdStyle}>
                      <div>{item.hotelName || "—"}</div>
                      <div style={{ color: "gray" }}>{item.checkIn || ""} → {item.checkOut || ""}</div>
                      {item.cityName && <div style={{ color: "gray" }}>{item.cityName}</div>}
                    </td>
                    <td style={tdStyle}>
                      <div>{item.roomName || "—"}</div>
                      {item.roomSetName && <div style={{ color: "gray" }}>{item.roomSetName}</div>}
                      {(item.roomCount || item.adults || item.children) ? (
                        <div style={{ color: "gray" }}>Rooms: {item.roomCount || 0} | Adults: {item.adults || 0} | Children: {item.children || 0}</div>
                      ) : null}
                    </td>
                    <td style={tdStyle}>
                      <div>{item.name || "—"}</div>
                      <div style={{ color: "gray" }}>{item.phone || "—"}</div>
                      {item.email && <div style={{ color: "gray" }}>{item.email}</div>}
                    </td>
                    <td style={tdStyle}>{item.bookingRef || "—"}</td>
                    <td style={tdStyle}>—</td>
                    <td style={tdStyle}>
                      <div style={{
                        background: cancelled ? "#dc3545" : "#0dcaf0",
                        color: cancelled ? "#fff" : "#000",
                        padding: 4, textAlign: "center", fontSize: 10
                      }}>
                        {(item.status || "").toUpperCase() || "BOOKED"}
                      </div>
                    </td>
                    <td style={tdStyle}>INR {Number(item.baseAmount || 0).toLocaleString("en-IN")}</td>
                    <td style={tdStyle}>{item.purchaseAmount != null ? `INR ${Number(item.purchaseAmount).toLocaleString("en-IN")}` : "—"}</td>
                    <td style={tdStyle}>
                      <Button size="sm" variant="outline-primary" style={{ fontSize: 10, marginBottom: 5, whiteSpace: "nowrap" }} onClick={item.downloadTicket}>
                        Download Ticket
                      </Button>
                      <Button size="sm" variant="outline-secondary" style={{ fontSize: 10, whiteSpace: "nowrap" }} onClick={item.downloadInvoice}>
                        Download Invoice
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No hotel bookings found</p>
      )}
      {totalPages > 1 && <Page count={totalPages} page={page} change={(_, v) => setPage(v)} />}
    </Fragment>
  );
};

export default HotelBookings;
